module.exports = __webpack_public_path__ + "img/float-right.b06480a9.svg";